import React from "react"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { fetchEntityDetailsById, SupportEntityQuery } from "../../../../support/admin/entities/supportEntityApi"
import { Grid, Skeleton, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    wrapList: {
        borderLeft: `0.25rem solid ${tailwindPalette.slate[200]}`,
        color: tailwindPalette.slate[700],
        paddingLeft: "1rem",
        display: "grid",
        marginTop: "1.5rem",
    },
    title: {
        marginBottom: ".5rem",
        fontWeight: "bold",
        fontSize: "1.115rem",
    },
    entityEmpty: {
        color: tailwindPalette.gray[500],
    },
}))

type MerchantDetailsProps = Readonly<{
    id: number
}>
export function MerchantAccessDetails({ id }: MerchantDetailsProps) {
    const { classes } = useStyles()

    const { data: entity, isLoading } = useApiQuery(fetchEntityDetailsById, {
        queryName: SupportEntityQuery.DETAILS_FOR_ENTITY,
        dependencies: {
            entityId: id,
        },
        select: (data) => data.entity,
        enabled: Boolean(id),
    })

    if (isLoading) {
        return (
            <Grid container className={classes.wrapList} gap={0.5}>
                <Skeleton variant="rectangular" width="100%" height={15} />
                <Skeleton variant="rectangular" width="100%" height={15} />
                <Skeleton variant="rectangular" width="100%" height={15} />
            </Grid>
        )
    }

    return (
        <Grid className={classes.wrapList} container direction="column">
            {entity?.entityDetails?.connectedCompanies ? (
                <>
                    <LocalizedStrict id="supplier-merchant-access-table-details-customers-title">
                        <Typography className={classes.title}>Customers:</Typography>
                    </LocalizedStrict>
                    {entity?.entityDetails?.connectedCompanies.map((company, index) => (
                        <Grid item key={index}>
                            <Typography variant="body1">{company.name}</Typography>
                        </Grid>
                    ))}
                </>
            ) : (
                <LocalizedStrict id="supplier-merchant-access-table-details-no-companies">
                    <Typography className={classes.entityEmpty}>There are no connected companies</Typography>
                </LocalizedStrict>
            )}
        </Grid>
    )
}
